<template>
  <span>
    <v-icon :color="color" @click="showDialog = true">mdi-alert-circle-outline</v-icon>

    <v-dialog v-model="showDialog" max-width="600">
      <v-card>
        <v-card-title />
        <v-card-text style="white-space:pre-wrap">{{message}}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="showDialog = false">閉じる</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </span>
</template>

<script>
  import ComponentMixin from "../ComponentMixin";

  export default {
    mixins: [ComponentMixin],
    type: "atom",
    name: "InfoIcon",
    data () {
      return {
        showDialog: false,
      };
    },
    props: {
      message: String,
      color: {
        type: String,
        default: undefined,
      }
    },
    computed: {
    },
    methods: {
    }
  }
</script>

<style lang="sass">

</style>
